var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4587 14.4624C18.2222 14.2552 17.9988 14.0595 17.8908 13.8652C17.8822 13.8495 17.8729 13.8336 17.8597 13.8117C17.4464 13.1503 17.2912 11.4997 17.1986 10.5138C17.1848 10.3657 17.1715 10.2241 17.1581 10.0916C16.9401 8.5596 16.4128 6.41811 15.1065 4.64997C14.2027 3.42658 13.0799 2.6004 11.7648 2.18984C11.6293 1.2359 10.8074 0.5 9.81661 0.5C8.82586 0.5 8.00368 1.2361 7.86841 2.19004C6.55339 2.6003 5.43049 3.42648 4.5267 4.65007C3.22044 6.41791 2.69303 8.5595 2.48074 10.0446C2.46185 10.2241 2.44851 10.3654 2.43468 10.5134C2.34197 11.4998 2.18684 13.1507 1.76976 13.818C1.6345 14.0594 1.41111 14.2553 1.17477 14.4626C0.593505 14.9719 -0.615864 16.032 0.380534 17.8821C0.57325 18.2402 0.94573 18.4626 1.35239 18.4626H18.2809C18.6873 18.4626 19.0596 18.2403 19.2527 17.8822C20.2489 16.0324 19.04 14.9722 18.4587 14.4624ZM11.7395 19.465H7.82342C7.66255 19.465 7.51132 19.5354 7.40839 19.6579C7.21538 19.888 7.26943 20.1945 7.30166 20.3776L7.30419 20.3923C7.51726 21.6135 8.57286 22.5 9.81427 22.5C11.0787 22.5 12.1636 21.5569 12.3376 20.3079L12.3414 20.2874C12.3629 20.174 12.4132 19.9084 12.2256 19.6818C12.1585 19.6009 12.0062 19.465 11.7395 19.465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.d5948e94f2d491a6c8ca20f30e0fe206.svg";
export { ForwardRef as ReactComponent };